import { ImageLoaderCSSStyleImpl } from '../../imageloader/imageloadercss';
import { LanguageConst } from '../../../../utils/resources/languageconst';

export class ArtistRowImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '80px', 
            // flex:'0.004',
            height: '100%',
            borderRadius: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH?"8px 0px 0px 8px": "8px 0px 0px 8px",
        };
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/artist/artistrowimageloadercss.tsx